import axios from "axios";
import { isApiKeyExpired } from "../utils/apiKey/apiKey";

const host = process.env.VUE_APP_API_IP;

const publicApi = axios.create({
  baseURL: host,
});

let apiKey = null;
let apiSignature = null;

publicApi.interceptors.request.use(async (config) => {
  const sid = localStorage.getItem("SID");
  const ulang = localStorage.getItem("language");
  const token = localStorage.getItem(process.env.VUE_APP_TOKEN_NAME) || null;

  if (sid) {
    config.headers["sid"] = sid;
  }

  if (token) {
    config.headers[process.env.VUE_APP_TOKEN_NAME] = `${token}`;
  }

  if (ulang) {
    config.headers["user-language"] = ulang;
  }

  if (!apiKey || !apiSignature || isApiKeyExpired(apiKey)) {
    try {
      const response = await axios.post(`${host}publicToken/token`);
      apiKey = response.data.token;
      apiSignature = response.data.signature;
    } catch (err) {
      console.error("[API KEY ERROR]", err);
    }
  }

  config.headers["x-api-key"] = apiKey;
  config.headers["x-api-signature"] = apiSignature;

  return config;
});

export default publicApi;
